import  { combineReducers } from 'redux';

// Listing Reducers
import categories from './CategoryReducer';
import moqs from './MoqReducer';
import products from './ProductReducer';
import user from './UserReducer';
import reviews from './ReviewReducer';
import bids from './BidReducer';
import delivery_locations from './DeliveryLocationReducer';
import recent_searches from './RecentSearchReducer'

export default combineReducers({

    categories,

    moqs,

    products,

    user,

    reviews,

    bids,

    delivery_locations,

    recent_searches

});